export default __webpack_public_path__ + "static/media/customer_Profile.8879a5d1.svg";